import React, { ReactNode } from "react";
import { COMMONS } from "./calendar/commons";
import { getMorningAndEveningCelebrations } from "./calendar/ordinariate-calendar";

const Row: React.FC<{ label: string; children: ReactNode }> = (props) => {
    return (
        <div
            style={{
                display: "flex",
                flexDirection: "row",
                alignItems: "flex-start",
                gap: 8,
                paddingLeft: 16,
            }}
        >
            <div style={{ minWidth: 80, fontWeight: "bold" }}>
                {props.label}
            </div>
            <div style={{ fontSize: "85%" }}>
                {props.children === "MISSING" ? (
                    <span style={{ backgroundColor: "#F99" }}>MISSING</span>
                ) : (
                    props.children
                )}
            </div>
        </div>
    );
};

export const Ordo: React.FC<{}> = () => {
    const isEpiphanyTransferred = false;
    const isAscensionTransferred = false;
    const isCorpusChristiTransferred = false;

    const regionLabels =
        localStorage.getItem("region-switches")?.split(";;;") ?? [];

    const year = getMorningAndEveningCelebrations(
        new Date().getFullYear(),
        isEpiphanyTransferred,
        isAscensionTransferred,
        isCorpusChristiTransferred,
        regionLabels
    ).slice(365);

    return (
        <>
            {year.map((liturgicalDay, dayIndex) => {
                const prevLiturgicalDay = year[dayIndex - 1];

                return (
                    <>
                        {liturgicalDay.date === 1 ? (
                            <div
                                style={{
                                    fontSize: "180%",
                                    fontWeight: "bold",
                                    padding: 12,
                                    borderBottom: "1px solid silver",
                                    textAlign: "center",
                                }}
                            >
                                {
                                    [
                                        "",
                                        "January",
                                        "February",
                                        "March",
                                        "April",
                                        "May",
                                        "June",
                                        "July",
                                        "August",
                                        "September",
                                        "October",
                                        "November",
                                        "December",
                                    ][liturgicalDay.month]
                                }{" "}
                                {liturgicalDay.year}
                            </div>
                        ) : (
                            <></>
                        )}
                        <div
                            style={{
                                display: "flex",
                                flexDirection: "row",
                                justifyContent: "flex-start",
                                borderBottom: "1px solid silver",
                            }}
                        >
                            <div
                                style={{
                                    width: 48,
                                    display: "flex",
                                    flexDirection: "column",
                                    alignItems: "center",
                                    flexShrink: 0,
                                }}
                            >
                                <div
                                    style={{
                                        textTransform: "uppercase",
                                        fontSize: "80%",
                                        fontWeight: "bold",
                                        paddingTop: 8,
                                    }}
                                >
                                    {liturgicalDay.day.slice(0, 3)}
                                </div>
                                <div
                                    style={{
                                        fontSize: "200%",
                                        lineHeight: 0.8,
                                        paddingBottom: 12,
                                    }}
                                >
                                    {liturgicalDay.date}
                                </div>
                            </div>
                            <div
                                style={{
                                    flexGrow: 1,
                                    padding: 8,
                                    paddingLeft: 12,
                                    display: "flex",
                                    flexDirection: "column",
                                    gap: 16,
                                    paddingBottom: 16,
                                }}
                            >
                                {liturgicalDay.morningOptions.map((option) => {
                                    return (
                                        <div>
                                            <div style={{ fontSize: "110%" }}>
                                                {option.regionNote ? (
                                                    option.regionNote + ": "
                                                ) : (
                                                    <></>
                                                )}
                                                <span
                                                    style={{
                                                        fontWeight: "bold",
                                                    }}
                                                >
                                                    {option.rank <= 8
                                                        ? option.title.toLocaleUpperCase()
                                                        : option.title}
                                                </span>{" "}
                                                (
                                                {option.optional
                                                    ? "optional "
                                                    : ""}
                                                {option.type}){" "}
                                                <a
                                                    href={`/se/${prevLiturgicalDay?.year}/${prevLiturgicalDay?.month}/${prevLiturgicalDay?.date}/${option.label}/first-evensong`}
                                                    target="_blank"
                                                >
                                                    EP1
                                                </a>{" "}
                                                <a
                                                    href={`/se/${liturgicalDay.year}/${liturgicalDay.month}/${liturgicalDay.date}/${option.label}/mattins`}
                                                    target="_blank"
                                                >
                                                    MP
                                                </a>{" "}
                                                <a
                                                    href={`/se/${liturgicalDay.year}/${liturgicalDay.month}/${liturgicalDay.date}/${option.label}/second-evensong`}
                                                    target="_blank"
                                                >
                                                    EP2
                                                </a>
                                            </div>

                                            <Row label="Collect">
                                                {option.collect ?? "MISSING"}
                                            </Row>
                                            {option.commons ? (
                                                <Row label="Common">
                                                    {option.commons
                                                        .map((common) =>
                                                            COMMONS[common]
                                                                ? common
                                                                : "MISSING"
                                                        )
                                                        .join(" OR ")}
                                                </Row>
                                            ) : (
                                                <>
                                                    {option.type ===
                                                        "solemnity" ||
                                                    option.type === "sunday" ||
                                                    (option.type === "feast" &&
                                                        option.feastHasFirstEvensong) ? (
                                                        <>
                                                            <Row label="EP1 Hymn">
                                                                {option.ep1HymnId ??
                                                                    "MISSING"}
                                                            </Row>
                                                            <Row label="EP1 V&R">
                                                                {option.ep1VandR
                                                                    ?.map((v) =>
                                                                        v.replace(
                                                                            /_/g,
                                                                            ""
                                                                        )
                                                                    )
                                                                    .join(
                                                                        " "
                                                                    ) ??
                                                                    "MISSING"}
                                                            </Row>
                                                            <Row label="EP1 Mag">
                                                                {option.ep1MagId ??
                                                                    "MISSING"}
                                                            </Row>
                                                        </>
                                                    ) : (
                                                        <></>
                                                    )}

                                                    <Row label="Inv">
                                                        {option.invId ??
                                                            "MISSING"}
                                                    </Row>
                                                    <Row label="MP Hymn">
                                                        {option.mpHymnId ??
                                                            "MISSING"}
                                                    </Row>
                                                    <Row label="MP V&R">
                                                        {option.mpVandR
                                                            ?.map((v) =>
                                                                v.replace(
                                                                    /_/g,
                                                                    ""
                                                                )
                                                            )
                                                            .join(" ") ??
                                                            "MISSING"}
                                                    </Row>
                                                    <Row label="Ben">
                                                        {option.mpBenId ??
                                                            "MISSING"}
                                                    </Row>
                                                    {(liturgicalDay.day ===
                                                        "sat" &&
                                                        (option.type ===
                                                            "feria" ||
                                                            option.type ===
                                                                "memorial")) ||
                                                    (liturgicalDay.date ===
                                                        24 &&
                                                        liturgicalDay.month ===
                                                            12) ||
                                                    liturgicalDay.morningOptions.find(
                                                        (opt) =>
                                                            opt.title ===
                                                            "Rogation Wednesday"
                                                    ) !== undefined ||
                                                    liturgicalDay.morningOptions.find(
                                                        (opt) =>
                                                            opt.title ===
                                                            "Ember Saturday in Whitsun Week"
                                                    ) !== undefined ? (
                                                        <></>
                                                    ) : (
                                                        <>
                                                            <Row label="EP2 Hymn">
                                                                {option.ep2HymnId ??
                                                                    "MISSING"}
                                                            </Row>
                                                            <Row label="EP2 V&R">
                                                                {option.ep2VandR
                                                                    ?.map((v) =>
                                                                        v.replace(
                                                                            /_/g,
                                                                            ""
                                                                        )
                                                                    )
                                                                    .join(
                                                                        " "
                                                                    ) ??
                                                                    "MISSING"}
                                                            </Row>
                                                            <Row label="EP2 Mag">
                                                                {option.ep2MagId ??
                                                                    "MISSING"}
                                                            </Row>
                                                        </>
                                                    )}
                                                </>
                                            )}
                                        </div>
                                    );
                                })}
                            </div>
                        </div>
                    </>
                );
            })}
        </>
    );
};
